import React from 'react';

import { SelectInput, SelectField } from 'react-admin';
import { Grid, Typography } from '@mui/material';
import { ruleCasePriorityChoices } from '../constants/casePriority';

const RuleCasePriorityInput = ({ disabled }: { disabled: boolean }) => (
  <Grid container spacing={1}>
    <Grid size={12}>
      <Typography variant="label">Case priority</Typography>
    </Grid>
    <Grid size={12}>
      {disabled ? (
        <SelectField
          source="casePriority"
          choices={ruleCasePriorityChoices}
          emptyText="-"
        />
      ) : (
        <SelectInput
          label="Case priority"
          source="casePriority"
          choices={ruleCasePriorityChoices}
          fullWidth
        />
      )}
    </Grid>
  </Grid>
);

export default RuleCasePriorityInput;
